module.exports = __webpack_public_path__ + "static/media/Logo_aeromegh.0a6a89a4.png";